// extracted by mini-css-extract-plugin
module.exports = {"checkMark":"confirm-modal_checkMark__2dfGL","title":"confirm-modal_title__2zn4Z","subtitle":"confirm-modal_subtitle__288vP","buttonsWrapper":"confirm-modal_buttonsWrapper__qD9SG"};